import React, { useState, useEffect } from 'react';
import ListLoader from './ListLoader';
import {
  AddKeyToItem,
  useEffectCancelled,
} from '@wajeez-web/components/helpers';
import { NoData, Sortable } from '@wajeez-web/components/ui';

export type WajeezListProps<TItem> = {
  isLoading?: boolean;
  containerType?: 'rows' | 'cards';
  gridItems?: number;
  getData?: (canceller: AbortController) => void | Promise<void>;
  data: TItem[];
  onOrder?: (items: TItem[]) => void;
  renderItem: (item: TItem, index: number) => JSX.Element;
  keyExtractor: (item: TItem, index: number) => string;
  itemsRerender?: boolean;
  handleNoData?: boolean;
  disabledSortable?: boolean;
};

function WajeezList<TItem>({
  containerType,
  getData,
  gridItems = 5,
  renderItem,
  data,
  isLoading,
  onOrder,
  keyExtractor,
  itemsRerender = false,
  handleNoData = true,
  disabledSortable,
}: WajeezListProps<TItem>) {
  useEffectCancelled((canceller: AbortController) => {
    getData && getData(canceller);
  }, []);

  const getList = () => {
    switch (containerType) {
      case 'rows':
        return onOrder ? (
          <Sortable
            data={data}
            setData={onOrder}
            keyExtractor={keyExtractor}
            renderItem={renderItem}
            itemsRerender={itemsRerender}
            disabled={disabledSortable}
          />
        ) : (
          <div className="divide-y border-b border-t">
            {data?.map(AddKeyToItem(renderItem, keyExtractor))}
          </div>
        );
      case 'cards': {
        return (
          <div
            className={`grid sm:grid-cols-${
              gridItems - 3 < 1 ? 1 : gridItems - 3
            }md:grid-cols-${gridItems - 2} lg:grid-cols-${
              gridItems - 1
            } xl:grid-cols-${gridItems} gap-5 `}
          >
            {data?.map(AddKeyToItem(renderItem, keyExtractor))}
          </div>
        );
      }

      default:
        return undefined;
    }
  };
  return (
    <div className="py-2 h-full w-full flex-col flex space-y-2">
      <div className="w-full h-full ">
        <div className="space-y-2  flex flex-col align-middle h-full w-full">
          {isLoading ? (
            <ListLoader loading={isLoading} />
          ) : data?.length ? (
            getList()
          ) : (
            handleNoData && <NoData />
          )}
        </div>
      </div>
    </div>
  );
}

export default WajeezList;
